/**
 * Product images are attached via the chat input attach button — no inline widget UI.
 */
export default function ProductImagesIntegration() {
  return null;
}
